import { render, staticRenderFns } from "./LegendConvert.vue?vue&type=template&id=365b996f&scoped=true&"
import script from "./LegendConvert.vue?vue&type=script&lang=js&"
export * from "./LegendConvert.vue?vue&type=script&lang=js&"
import style0 from "./LegendConvert.vue?vue&type=style&index=0&id=365b996f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b996f",
  null
  
)

export default component.exports